export default __webpack_public_path__ + "static/spinner-7b3fc3e36770d76ca4de7bed8b6543ec.gif";